import {useToast, useDisclosure, VStack} from "@chakra-ui/react";
import {useNavigate} from "react-router-dom";
import {useEffect} from "react";
import LoadForm from "../../components/CreateRequest/RequestForm";
import {useCreateRequest} from "../../context";
import {stateChecker as check} from "../../helper/utils";
import {HeaderComponent, IntentIndicator, ListContainer} from "../../components/UI";
import {VerificationModal} from "../../components/RequestListing";


function AddLoadPage() {
	const toast = useToast();
    const {actions, state} = useCreateRequest();
    const {isOpen, onOpen, onClose} = useDisclosure();
    const navigate = useNavigate();
    function handleVerified() {
        actions.clearForm();
        handleReset(true)
    }
    function handleReset(redirect?: boolean) {
        if (redirect) {
            onClose();
            actions.setRedirect(false);
            navigate("/request-list");
        }
    }
	useEffect(function () {
        let status: "error"|"success"|undefined;
        if (check.isError(state.loadingState)) {
            status = "error";
        }
        if (check.isSuccess(state.loadingState)) {
            status = "success";
        }
		if (state.message && status) {
			toast({
                containerStyle: {whiteSpace: "pre-line", lineHeight: "1"},
				description: state.message.desc,
                duration: 5000,
				isClosable: true,
                position: "top",
                status,
                title: state.message.title,
                onCloseComplete: actions.clearError
			});
		}
	}, [state.loadingState, state.message]);
    useEffect(function () {
        const val = state.requestState;
        if (val === "pending") {
            onOpen();
        }
        if (val === "verified") {
            setTimeout(handleVerified, 5000);
        }
        if (val === "failed") {
            setTimeout(onClose, 5000);
        }
    }, [state.requestState]);
    return <VStack
        h="100dvb"
        w="full"
        alignItems="start"
        gap="1rem"
        overflowY="clip"
        justifyContent={{base: "start", md: "center"}}
        py=".5rem"
    >
        <HeaderComponent
            title="New Request"
            h={{base: "auto", md: 0}}
            pt={{md: 0}}
            pb={{md: 0}}
        />
        <ListContainer
            maxW={{lg: "480px", "2xl": "540px"}}
            maxH={{md: "95%", lg: "min(900px, 95%)"}}
            h={{base: `calc(100dvb - 190px)`, md: "85%"}}
            minW={{base: "100%", md: "50%", lg: "50%"}}
            justifyContent="stretch"
            px={{base: "1rem", md: "32px", lg: "16px"}}
            position="relative"
            w={"min(35rem, 100%)"}
            p={{base: "0 1rem", md: "1rem 2rem", lg: "1rem"}}
            flex={{base: "2 1 58dvb"}}
        >
            <IntentIndicator for="creation"/>
            {state.requestState !== "not-sent" && <VerificationModal
                isOpen={isOpen}
                onClose={onClose}
                status={state.requestState}
            />}
            <LoadForm/>
        </ListContainer>
    </VStack>;
}

export default AddLoadPage;
